import React, { useContext } from 'react';
import Divider from '../../Divider/Divider';
import Div from '../../Element/Div/Div';
import styles from '../Tabs.module.scss';
import ComposableTabsContext from './ComposableTabsContext';

/** Component that renders active tabs content.
 * ComposableTabsPanel should be rendered inside ComposableTabs below ComposableTabsList component */
const ComposableTabsPanel: React.FunctionComponent = ({ children }) => {
  const { tabsId, activeTab } = useContext(ComposableTabsContext);
  return (
    <>
      <Divider />

      <Div
        id={`${tabsId}-panel`}
        tabIndex={0}
        className={styles.tabs_tabContent}
        aria-labelledby={`${tabsId}-tab-button-${activeTab}`}
      >
        {children}
      </Div>
    </>
  );
};

export default ComposableTabsPanel;
